import { styled, Box } from '@mui/material';
import { lighten } from '@mui/material/styles';

export const WarehouseDetailCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  alignItems: 'center',
  padding: theme.spacing(1.5),
  gap: theme.spacing(1),
  borderRadius: 10,
}));

export const WarehouseDetailCardIconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 46,
  height: 46,
  backgroundColor: lighten(theme.palette.primary.main, 0.9),
  color: theme.palette.primary.main,
  borderRadius: 10,
  fontSize: theme.typography.pxToRem(27),
}));
